export default class IdNumberValidator {
  static isValid(value) {
    return (IdNumberValidator.isChecksumValid(value) &&
      IdNumberValidator.isDobValid(value));
  }

  static isChecksumValid(value) {
    var parts = value.split("")
    let actual_checksum_digit = parts.pop()
    let even_digits = parts.filter(function(_, i) {
      return (i + 1) % 2 == 0
    })
    let odd_digits_without_last_digit = parts.filter(function(_, i) {
      return (i + 1) % 2 != 0
    })

    let sum_of_odd_digits = odd_digits_without_last_digit.map(parseFloat).reduce((a, b) => a + b, 0)
    let even_digits_times_two = String(parseFloat(even_digits.join("")) * 2)
    let sum_of_even_digits = even_digits_times_two.split("").map(parseFloat).reduce((a, b) => a + b, 0)
    let total_sum = sum_of_odd_digits + sum_of_even_digits

    let checksum_digit = String((10 - (total_sum % 10)) % 10)
    let valid = parts.length == 12 &&
      actual_checksum_digit == checksum_digit;
    return valid;
  }

  static isDobValid(value) {
    try {
      let currentYear = new Date().getFullYear().toString().match(/.{1,2}/g)[1]
      let dateOfBirth = value.substr(0, 6).match(/.{1,2}/g)

      if (currentYear > dateOfBirth[0]){
        dateOfBirth[0] = `20${dateOfBirth[0]}`
      } else {
        dateOfBirth[0] = `19${dateOfBirth[0]}`
      }

      let date = new Date(dateOfBirth.join("/"))
      return !isNaN(date);
    } catch(_e) {
      return false;
    }
  }
}
